import classNames from 'classnames';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import isString from 'lodash/isString';
import React from 'react';

import {
  content,
  hemXVideoWrapper,
  img,
  imgDesktop,
  imgMobile,
  overlay,
  video,
  videoWrapper,
  wrapper,
} from './BackgroundImage.module.scss';

type Props = {
  as?: keyof JSX.IntrinsicElements;
  image?: IGatsbyImageData | string;
  imageAlt?: string;
  mobileImage?: IGatsbyImageData;
  mobileImageAlt?: string;
  loading?: 'eager' | 'lazy';
  staticAsset?: unknown; // <StaticImage />
  staticAssetMobile?: unknown; // <StaticImage />
  className?: string;
  darken?: boolean;
  children?: React.ReactNode;
  placeItems?: 'start' | 'center';
  isHemX?: boolean;
  style?: React.CSSProperties;
};

export const BackgroundImage: React.FC<Props> = ({
  as = 'div',
  image,
  imageAlt = '',
  mobileImage,
  mobileImageAlt = '',
  children,
  loading = 'lazy',
  staticAsset,
  staticAssetMobile = null,
  darken = false,
  isHemX = false,
  className,
  placeItems = 'center',
  ...rest
}): JSX.Element => {
  const Tag = as;

  if (!image && !staticAsset) {
    return null;
  }

  const isVideo = isString(image);

  return (
    <Tag className={classNames(wrapper, className)} {...rest}>
      {isVideo && !staticAsset ? (
        <div
          className={classNames(videoWrapper, { [hemXVideoWrapper]: isHemX })}
        >
          <video
            className={video}
            src={image}
            autoPlay
            loop
            muted
            playsInline
          />
        </div>
      ) : null}

      {!isVideo && !image && staticAsset ? (
        <>
          {staticAsset}
          {staticAssetMobile}
        </>
      ) : null}

      {!isVideo && image && !staticAsset ? (
        <>
          <GatsbyImage
            className={classNames(img, {
              [imgDesktop]: mobileImage !== undefined,
            })}
            alt={imageAlt}
            image={image}
            loading={loading}
          />
          {mobileImage !== undefined ? (
            <GatsbyImage
              className={classNames(img, imgMobile)}
              alt={mobileImageAlt}
              image={mobileImage}
              loading={loading}
            />
          ) : null}
        </>
      ) : null}

      {darken && !isVideo && <div className={overlay} />}
      <div className={content} style={{ placeItems }}>
        {children}
      </div>
    </Tag>
  );
};
